import { useState, useEffect } from 'react';
import * as THREE from 'three';
import { FigureModel, AssetModel } from '../../models';
import { useAvatarStats } from '../../hooks';
import {
  StyledFlexPreview,
  StyledModelViewer,
  StyledFlexView,
  ItemFrame,
  ItemBg,
  ItemImage,
  ItemEmpty,
  LeftPanel,
  RightPanel,
  StatFrame,
  StatData,
  UserName,
  StatIcon,
  StatName,
  StatValue
} from './FlexPreview.styled';
import { ModelLoading } from '../';
import { getAvatarById } from '../../providers/BasejumpApiProvider';

const FlexAvatar = ({ glbPath }) => {
  return (
    <StyledModelViewer>
      <model-viewer alt="Broadsider" disable-zoom disable-pan disable-rotate camera-orbit='180deg 75deg 100%' src={glbPath}/>
    </StyledModelViewer>
  );
}

export default function FlexPreview({ avatarId }) {
  const [avatarData, setAvatarData] = useState(null);
  const [selectedAvatar, setSelectedAvatar] = useState(null);
  const [items, setItems] = useState([]);
  const { stats } = useAvatarStats(items, selectedAvatar);

  const setupAvatar = async (avatarId) => {
    const avatar = await getAvatarById(avatarId);
    avatar.equipment.forEach(it => {
      it.equipped = true;
      it.slot = it.slot_id;
    });

    const equipmentItems = avatar.equipment.map((t) => AssetModel.fromBasejumpEquipment(t));
    const avatarItem = FigureModel.fromBasejumpAvatar(avatar);
    setAvatarData(avatar);
    setSelectedAvatar(avatarItem);
    setItems(equipmentItems);
  };

  useEffect(() => {
    if (avatarId) {
      setupAvatar(avatarId);
    }
  }, [avatarId]);

  return (
    <StyledFlexPreview>
      {avatarData ? (
        <StyledFlexView>
          <UserName>{avatarData.owner.user_name}</UserName>
          <FlexAvatar glbPath={avatarData.vrm_url}/>
          <LeftPanel>
            <StatFrame>
              <StatIcon src='/assets/stat_icon_health_white.svg'/>
              <StatData>
                <StatName>Health</StatName>
                <StatValue>{stats.healthPoints}</StatValue>
              </StatData>
            </StatFrame>
            <StatFrame>
              <StatIcon src='/assets/stat_icon_weapon_white.svg'/>
              <StatData>
                <StatName>Attack</StatName>
                <StatValue>{stats.attackPoints}</StatValue>
              </StatData>
            </StatFrame>
            <StatFrame>
              <StatIcon src='/assets/stat_icon_armour_white.svg'/>
              <StatData>
                <StatName>Defense</StatName>
                <StatValue>{stats.defencePoints}</StatValue>
              </StatData>
            </StatFrame>
            <StatFrame>
              <StatIcon src='/assets/stat_icon_speed_white.svg'/>
              <StatData>
                <StatName>Speed</StatName>
                <StatValue>{stats.speed}</StatValue>
              </StatData>
            </StatFrame>
            <StatFrame>
              <StatIcon src='/assets/stat_icon_crit_white.svg'/>
              <StatData>
                <StatName>Crit Chance</StatName>
                <StatValue>{stats.criticalChance}</StatValue>
              </StatData>
            </StatFrame>
          </LeftPanel>
          <RightPanel>
	    {items[0] ? (
              <ItemFrame>
                <ItemBg src='/assets/item_bg.png'/>
                <ItemImage src={items[0].getImgSource()}/>
              </ItemFrame>
            ) : (
              <ItemFrame $empty={true}>
                <ItemEmpty>Empty</ItemEmpty>
              </ItemFrame>
            )}
	    {items[1] ? (
              <ItemFrame>
                <ItemBg src='/assets/item_bg.png'/>
                <ItemImage src={items[1].getImgSource()}/>
              </ItemFrame>
            ) : (
              <ItemFrame $empty={true}>
                <ItemEmpty>Empty</ItemEmpty>
              </ItemFrame>
            )}
	    {items[2] ? (
              <ItemFrame>
                <ItemBg src='/assets/item_bg.png'/>
                <ItemImage src={items[2].getImgSource()}/>
              </ItemFrame>
            ) : (
              <ItemFrame $empty={true}>
                <ItemEmpty>N/A</ItemEmpty>
              </ItemFrame>
            )}
          </RightPanel>
        </StyledFlexView>
      ) : (
        <ModelLoading/>
      )}
    </StyledFlexPreview>
  )
}
